// extracted by mini-css-extract-plugin
export var black = "_2l-6";
export var brand = "_2l-1";
export var ddefault = "_2l-0";
export var error = "_2l-3";
export var gray = "_2l-2";
export var highContrast = "_2l-8";
export var outline = "_2l-7";
export var success = "_2l-5";
export var warning = "_2l-4";